module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/people_200-15f0c7ce4d0f92469776f64aa43aab29.png";